export default __webpack_public_path__ + "static/media/AppCameraH.7890c80d.png";